import { render, staticRenderFns } from "./StatNumber.vue?vue&type=template&id=8efc9198&scoped=true&"
import script from "./StatNumber.vue?vue&type=script&lang=js&"
export * from "./StatNumber.vue?vue&type=script&lang=js&"
import style0 from "./StatNumber.vue?vue&type=style&index=0&id=8efc9198&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efc9198",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardSubtitle,VCardText,VIcon,VSkeletonLoader,VTooltip})
